import { ContentType } from "@/types/content";

/**
 * Infers the content type from a URL based on file extension
 */
export function getContentTypeFromUrl(url: string | null | undefined): ContentType {
  if (!url) return "web";
  
  const lowerUrl = url.toLowerCase();
  
  // Check file extensions
  if (lowerUrl.endsWith(".pdf")) return "pdf";
  if (lowerUrl.endsWith(".doc") || lowerUrl.endsWith(".docx")) return "doc";
  if (lowerUrl.endsWith(".mp4") || lowerUrl.endsWith(".webm") || lowerUrl.endsWith(".mov") || lowerUrl.endsWith(".avi")) return "video";
  if (lowerUrl.endsWith(".mp3") || lowerUrl.endsWith(".wav") || lowerUrl.endsWith(".ogg") || lowerUrl.endsWith(".m4a") || lowerUrl.endsWith(".aac")) return "audio";
  if (lowerUrl.endsWith(".txt") || lowerUrl.endsWith(".md")) return "text";
  
  // Check for YouTube URLs
  if (lowerUrl.includes("youtube.com") || lowerUrl.includes("youtu.be")) return "youtube";
  
  // Default to web for URLs without recognized extensions
  return "web";
}
